export const LOAN_CHANNEL_CONSTANTS = {
	CB: "CB",
	NDC: "NDC",
	CORR: "CORR",
	WHS: "WHS",
};

export const TPO_SECONDARY = "TPO Secondary";
export const BROKER_ADMIN = "broker admin";
export const COMPANY_ADMIN = "Company admin";
export const TPO_SECONDARY_USER_TITLE = "TPO Secondary";
export const TPO_COMPANY_ADMIN_USER_TITLE = "Company Admin";
export const TPO_LOAN_PROCESSOR_USER_TITLE = "Loan Processor";
export const TPO_LOAN_OFFICER_USER_TITLE = "Loan Officer";
export const TPO_BROKER_ADMIN_USER_TITLE = "Broker Admin";
